import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";

import { ActionButtons, DeleteConfirmationModal } from "@components";
import { OtherServicesForm } from "./OtherServicesForm";

import { OtherServiceType } from "@type/HRM/services";
import { otherServicesValidation } from "@validations/HRM/employee/sevicesValidation";
import {
  convertDocumentData,
  revertDocumentData,
} from "@utils/documentDataConvert";

interface OtherServicesPropsType {
  otherServicesInfo: OtherServiceType;
  changeOtherServicesInfo: (data: OtherServiceType) => void;
  removeOtherServicesInfo: (otherServiceID: number) => void;
  getServicesRequestOngoing: boolean;
  updateOtherServiceRequestOngoing: boolean;
  deleteOtherServiceRequestOngoing: boolean;
  isProfileDisabled: boolean;
}

export const OtherServices = ({
  otherServicesInfo,
  changeOtherServicesInfo,
  removeOtherServicesInfo,
  getServicesRequestOngoing,
  updateOtherServiceRequestOngoing,
  deleteOtherServiceRequestOngoing,
  isProfileDisabled,
}: OtherServicesPropsType) => {
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] =
    useState<boolean>(false);

  const closeConfirmationModal = () => setIsConfirmationModalOpen(false);

  const deleteAction = () => {
    closeConfirmationModal();
    removeOtherServicesInfo(otherServicesInfo.id);
  };

  const methods = useForm<OtherServiceType>({
    resolver: yupResolver(otherServicesValidation),
    values: revertDocumentData(otherServicesInfo) as OtherServiceType,
  });

  const { handleSubmit } = methods;
  const onSubmit: SubmitHandler<OtherServiceType> = (
    data: OtherServiceType,
  ) => {
    changeOtherServicesInfo(convertDocumentData(data));
  };

  let isSaving = getServicesRequestOngoing || updateOtherServiceRequestOngoing;
  let isDeleting =
    getServicesRequestOngoing || deleteOtherServiceRequestOngoing;

  return (
    <>
      {isConfirmationModalOpen && (
        <DeleteConfirmationModal
          isModalOpen={isConfirmationModalOpen}
          action={deleteAction}
          onClose={closeConfirmationModal}
        />
      )}
      <FormProvider {...methods}>
        <form className="container" onSubmit={handleSubmit(onSubmit)}>
          <OtherServicesForm isProfileDisabled={isProfileDisabled} />
          {!isProfileDisabled && (
            <ActionButtons
              isSaving={isSaving}
              isDeleting={isDeleting}
              deleteAction={() => setIsConfirmationModalOpen(true)}
            />
          )}
        </form>
      </FormProvider>
    </>
  );
};
